let index = 0;

export default {
  generate: function() {
    return "lui-id-" + (index++);
  }
};


/** WEBPACK FOOTER **
 ** ./src/utils/unique-id.js
 **/